<pos-app-spinner [show]="loading"></pos-app-spinner>

<div *ngIf="actionOrderDetailCard">
  <form [formGroup]="orderDetailCardForm" (submit)="submitOrderDetailCardForm(true)">
    <div class="modal-header">
      <h4 class="modal-title">ORDER DETAILS</h4>
      <div *ngIf="currentEventData?.ValidSO === 'N'" class="col d-flex float-end justify-content-end text-danger">WARNING: NO MORE FIT LINE REMAINING</div>
    </div>
    <div class="modal-body">
      <div class="border mb-2">
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">ORDER</label>
            <div class="col-7">
              <input class="form-control" [value]="currentEventData?.OrderNumber" [readonly]="true" />
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">CUSTOMER</label>
            <div class="col-7">
              <input class="form-control" [value]="currentEventData?.CustomerName" [readonly]="true" />
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <div class="col-11">
              <button type="button" class="btn" (click)="viewScheduleHistory()">
                SCHEDULE HISTORY&nbsp;<span class="badge badge-light ml-2 bg-dark"></span>
              </button>
            </div>
            <div class="col-1">
              <button type="button" class="btn" (click)="showNoteView()">NOTES</button>
            </div>
          </div>
        </div>
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">ORDER TYPE</label>
            <div class="col-7">
              <ng-select formControlName="jobTypeCode" [clearable]="false">
                <ng-option *ngFor="let jobType of jobTypeList" [value]="jobType.code">
                  {{ jobType.shortDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">PHONE</label>
            <div class="col-7 pr-2">
              <input class="form-control" formControlName="customerPhone" />
            </div>
          </div>

          <div class="col-4 d-flex align-items-center">
            <label class="col-4">JOB OWNER</label>
            <div class="col-7 pr-2">
              <input class="form-control" formControlName="jobOwner" />
            </div>
          </div>
        </div>

        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">VEHICLE</label>
            <div class="col-7 pr-2">
              <input class="form-control" [value]="currentEventData?.CarShortDesc" [readonly]="true" />
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">REGO</label>
            <div class="col-7 pr-2">
              <input class="form-control" [value]="currentEventData?.CarRego" [readonly]="true" />
            </div>
          </div>

          <div class="col-4 d-flex align-items-center">
            <label class="col-4">VEHICLE STATUS</label>
            <div class="col-7 pr-2">
              <input class="form-control" [value]="currentEventData?.VehicleStatus" [readonly]="true" />
            </div>
          </div>
        </div>
      </div>
      <div class="border mb-2">
        <div style="background-color: lightgray; margin: 1px; padding: 2px">
          <div class="row row-gap m-1">
            <div class="col-3 d-flex align-items-center">
              <label class="col-6">SPLIT</label>
              <div class="col-4 pr-1">
                <input class="form-control" [value]="currentEventData?.JobSplitText" [readonly]="true" />
              </div>
            </div>
            <div class="col-3 d-flex align-items-center">
              <label class="col-8">STANDARD HOURS</label>
              <div class="col-4 pr-1">
                <input class="form-control" [value]="currentEventData?.StandardFitHours" [readonly]="true" />
              </div>
            </div>
            <div class="col-3 d-flex align-items-center">
              <label class="col-8">SCHEDULED HOURS</label>
              <div class="col-4 pr-1">
                <input class="form-control" [value]="currentEventData?.ScheduledHours" [readonly]="true" />
              </div>
            </div>
            <!-- <div class="col-3 d-flex align-items-center">
              <label class="col-4">FIT DATE</label>
              <div class="col-8">
                <div class="input-group">
                  <input class="form-control" formControlName="jobDate"  />
                </div>
              </div>
            </div> -->
            <div class="col-3 d-flex align-items-center">
              <label class="col-4">FIT DATE</label>
              <div class="col-8">
                <div class="input-group">
                  <input
                    class="form-control"
                    formControlName="fitDate"
                    name="d2"
                    ngbDatepicker
                    #d="ngbDatepicker"
                    [dayTemplate]="customDay"
                    [placement]="'left'"
                    container="body"
                    (dateSelect)="showDetails($event)"
                    (navigate)="navigateCalendar($event)"
                    [markDisabled]="isDisabled"
                    autoClose="false"
                    [startDate]="getToday()"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary calendar text-white btn-picker"
                      (click)="d.toggle()"
                      (click)="streamOpened($event)"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-gap m-1">
            <div class="col-8 d-flex align-items-center">
              <label class="col-2">DESCRIPTION</label>
              <div class="col-10 pr-1">
                <input class="form-control" formControlName="jobDescription" maxlength="100" />
              </div>
            </div>
            <div class="col-3 d-flex align-items-center">
              <label class="col-6">ALLOCATED</label>
              <div class="col-6 pr-1">
                <input class="big-checkboxOrder" type="checkbox" (click)="resetResources()" formControlName="allocate" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="currentEventData?.ResourceAssigned.length > 0">
          <div class="row row-gap m-2">
            <div class="col-6 d-flex align-items-center">
              <div class="col-3">
                <label>4X4 TECHNICIAN</label>
              </div>
              <div class="col-9 pr-2">
                <ng-multiselect-dropdown
                  style="white-space: normal"
                  [settings]="resourceSettings"
                  [data]="technicianResourceList"
                  formControlName="technicianResource"
                >
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-6 d-flex align-items-center">
              <div class="col-3">
                <label>OTHER RESOURCES</label>
              </div>
              <div class="col-9 pr-2">
                <ng-multiselect-dropdown
                  style="white-space: normal"
                  [settings]="otherResourceSettings"
                  [data]="otherResourceList"
                  formControlName="otherResource"
                >
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="col d-flex float-end justify-content-end">
        <button class="btn btn-cancel mx-1 px-2" (click)="handleCloseModal(true)">CANCEL</button>
        <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!orderDetailCardForm.valid || !isFormValid">SAVE</button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="notesCardView">
  <div class="modal-body">
    <app-order-card-notes
      [currentEventData]="currentEventData"
      [preloadAttachments]="allAttachments"
      [orderNumber]="currentEventData?.OrderNumber"
      [orderType]="currentEventData?.OrderType"
      [orderCompany]="defaultCompanyCode"
      (reloadedAttachments)="loadAllAttachments.emit()"
      (closeActiveNoteModal)="handleCloseNoteModal($event)"
    ></app-order-card-notes>
    <div *ngIf="orderLines.length > 0">
      <h5 class="modal-title">SALES ORDER LINES</h5>
      <table class="table table-striped table-bordered w-100">
        <thead>
          <tr>
            <!-- <th *ngIf="!isReadOnly" scope="col" class="text-uppercase">
                <label>ACTION</label>
              </th> -->
            <th scope="col" class="text-uppercase">
              <label>NOTES</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>CODE</label>
            </th>
            <th scope="col" class="text-uppercase w-50">
              <label>DESCRIPTION</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>QTY</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>COLOUR</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>STD HRS</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>ON THIS JOB</label>
            </th>
          </tr>
        </thead>
        <tbody *ngFor="let item of orderLines; index as i">
          <tr>
            <td class="text-center text-capitalize">
              <div *ngIf="item.detailAttachmentArray.length > 0" (click)="showMoreDetails(i)"><mat-icon>attachment_file</mat-icon></div>
            </td>
            <td class="text-center text-capitalize"></td>
            <td class="text-center text-capitalize">
              {{ item.string }}
            </td>
            <td class="text-center text-capitalize">
              {{ item.quantity }}
            </td>
            <td class="text-center text-capitalize">
              {{ item.colour }}
            </td>
            <td class="text-center text-capitalize">
              {{ item.fitHours }}
            </td>
            <td class="text-center text-capitalize">
              {{ item.lineOnInputJobTF ? 'YES' : 'NO' }}
            </td>
          </tr>
          <tr *ngIf="item.detailAttachmentArray.length > 0 && checkViewStatus(i)">
            <td colspan="12">
              <div>
                <app-sales-orderline-notes
                  [currentEventData]="currentEventData"
                  [preloadAttachments]="item.detailAttachmentArray"
                  [orderNumber]="currentEventData?.OrderNumber"
                  [orderType]="currentEventData?.OrderType"
                  [orderCompany]="defaultCompanyCode"
                  (reloadedAttachments)="loadAllAttachments.emit()"
                  (closeActiveNoteModal)="handleCloseNoteModal($event)"
                ></app-sales-orderline-notes>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <button #closebutton class="btn btn-cancel m-3 float-end" (click)="handleCloseNoteModal($event)">CLOSE</button>
</div>
<div *ngIf="scheduleHistoryView">
  <div class="modal-header">
    <h4 class="modal-title">SCHEDULED HISTORY</h4>
  </div>

  <div class="modal-body">
    <label *ngIf="ledgerResultArray?.length < 0">NO LEDGER RECORDS FOUND</label>
    <div *ngIf="ledgerResultArray?.length > 0">
      <app-schedule-history-notes [ledgerResultArray]="ledgerResultArray" (closeActiveNoteModal)="handleCloseNoteModal($event)">
      </app-schedule-history-notes>
    </div>
  </div>
  <button #closebutton class="btn btn-cancel m-3 float-end" (click)="handleCloseNoteModal($event)">CLOSE</button>
</div>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div id="calanderDayParent{{ date.day }}{{ date.month }}{{ date.year }}" *ngIf="date.month === currentMonth" style="width:50px; margin-left:-10px">
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calanderDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      data-toggle="tooltip"
      data-placement="top"
      title=""
    >
      {{ date.day }}
    </div>
    <div id="calanderValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>
